import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useParams, useNavigate } from "react-router-dom";
import "../../assets/styles/createproduct.css";
import { RiDeleteBin5Line } from "react-icons/ri";
import Modal from "../../components/common/modal";
import { TiTick } from "react-icons/ti";
import { useViewTagsList } from "../../hooks/tags/tags.list";
import { useViewIndustryList } from "../../hooks/industries/industrylist";
import { useViewMacrofamily } from "../../hooks/macrofamily/macro.showall";
import { useViewCategoryList } from "../../hooks/categorys/category.list";
import { useProductStore } from "../../hooks/products/product.store";
import { toast } from "react-toastify";



const AddProduct = () => {
  const { id } = useParams(); // Get product ID from URL

  // Form field states
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [description, setDescription] = useState("");
  // Refs for focusing invalid fields
  const titleRef = useRef(null);
  const slugRef = useRef(null);
  const descriptionRef = useRef(null);
  const [macroFamily, setMacroFamily] = useState([]);
  const [category, setCategory] = useState(null);
  const [industry, setIndustry] = useState([]);
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState("");

  const [bulkImageFiles, setBulkImageFiles] = useState([]);
  const [bulkImagePreviews, setBulkImagePreviews] = useState([]);
  const [bulkVideos, setBulkVideos] = useState([]);
  const [videoUrl, setVideoUrl] = useState("");
  const [videoTitle, setVideoTitle] = useState("");
  const [videoDescription, setVideoDescription] = useState("");
  const [catalogEntries, setCatalogEntries] = useState([]);
  const [catalogFile, setCatalogFile] = useState(null);
  const [catalogTitle, setCatalogTitle] = useState("");
  const [catalogDescription, setCatalogDescription] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isTagDropdownOpen, setIsTagDropdownOpen] = useState(false);
  const tagDropdownRef = useRef(null);
  const catalogFileInputRef = useRef(null);

  // Fetch dropdown data from API
  const { data: categoriesData } = useViewCategoryList();
  const { data: industriesData } = useViewIndustryList();
  const { data: macrofamiliesData } = useViewMacrofamily();
  const { data: tagsData } = useViewTagsList();
  const { mutate: storeProduct, } = useProductStore();

  const [tags, setTags] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({
    title: "",
    slug: "",
  });
  const redirectTimerRef = useRef(null);



  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tagDropdownRef.current && !tagDropdownRef.current.contains(event.target)) {
        setIsTagDropdownOpen(false);
      }
    };

    if (isTagDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isTagDropdownOpen]);


  const readThumbnailURL = (input) => {
    if (input.files && input.files[0]) {
      const file = input.files[0];
      setThumbnailFile(file);
      const reader = new FileReader();
      reader.onload = function (e) {
        setThumbnailPreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const navigate = useNavigate();
  const [uploadSave, setUploadSave] = useState(false);


  const getEmbedUrl = (url) => {
    if (
      typeof url === "string" &&
      (url.includes("youtube.com") || url.includes("youtu.be"))
    ) {
      let videoId = "";
      if (url.includes("watch?v=")) {
        videoId = url.split("watch?v=")[1].split("&")[0];
      } else if (url.includes("youtu.be/")) {
        videoId = url.split("youtu.be/")[1].split("?")[0];
      }
      return `https://www.youtube.com/embed/${videoId}`;
    }
    return null;
  };


  const handleBulkImageChange = (e) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      const validImageTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/webp"];
      const validExtensions = [".jpg", ".jpeg", ".png", ".gif", ".webp"];
      const validFiles = [];
      const invalidFiles = [];

      files.forEach((file) => {
        const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        if (validImageTypes.includes(file.type) && validExtensions.includes(ext)) {
          validFiles.push(file);
        } else {
          invalidFiles.push(file.name);
        }
      });

      if (invalidFiles.length > 0) {
        toast.error("Only image files are supported (JPG, PNG, GIF, WebP). PDF and other formats are not allowed.", { autoClose: 5000 });
      }

      if (validFiles.length > 0) {
        const newPreviews = validFiles.map((file) => URL.createObjectURL(file));
        setBulkImageFiles((prev) => [...prev, ...validFiles]);
        setBulkImagePreviews((prev) => [...prev, ...newPreviews]);
      }
    }
  };

  const handleAddVideoUrl = (e) => {
    e.preventDefault();
    if (videoUrl.trim()) {
      setBulkVideos((prev) => [
        ...prev,
        {
          url: videoUrl.trim(),
          title: videoTitle.trim(),
          description: videoDescription.trim(),
        },
      ]);
      setVideoUrl("");
      setVideoTitle("");
      setVideoDescription("");
    }
  };


  const handleDeleteImage = (indexToDelete) => {
    setBulkImageFiles((prev) => prev.filter((_, index) => index !== indexToDelete));
    setBulkImagePreviews((prev) => prev.filter((_, index) => index !== indexToDelete));
  };

  const handleImageClick = (img, index) => {
    setSelectedImage(img);
    setSelectedImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    navigate("/products/ProductList");
  };

  useEffect(() => {
    return () => {
      if (redirectTimerRef.current) {
        clearTimeout(redirectTimerRef.current);
      }
    };
  }, []);

  const handleAddCatalog = (e) => {
    e.preventDefault();
    if (!catalogFile) {
      toast.error("Please select a PDF file for catalogue.");
      return;
    }

    setCatalogEntries((prev) => [
      ...prev,
      {
        file: catalogFile,
        title: catalogTitle.trim(),
        description: catalogDescription.trim(),
      },
    ]);
    setCatalogFile(null);
    setCatalogTitle("");
    setCatalogDescription("");
    if (catalogFileInputRef.current) {
      catalogFileInputRef.current.value = "";
    }
  };

  const handleCatalogFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
    if (file.type !== "application/pdf" && ext !== ".pdf") {
      toast.error("Only PDF files are supported for catalogues.");
      e.target.value = "";
      return;
    }

    setCatalogFile(file);
  };

  const handleRemoveCatalog = (indexToDelete) => {
    setCatalogEntries((prev) => prev.filter((_, index) => index !== indexToDelete));
  };

  const handleRemoveVideo = (indexToDelete) => {
    setBulkVideos((prev) => prev.filter((_, index) => index !== indexToDelete));
  };

  // Prepare dropdown options from API data
  const categoryOptions = categoriesData?.data || categoriesData?.data?.data || [];
  const industryOptions = industriesData?.data || [];
  const macrofamilyOptions = macrofamiliesData?.data?.macros || [];
  const tagOptions =
    tagsData?.data?.tags ||
    tagsData?.data ||
    tagsData?.tags ||
    [];

  const validateForm = () => {
    const errors = {
      title: "",
      slug: "",
    };

    const trimmedTitle = title.trim();
    const trimmedSlug = slug.trim().toLowerCase();
    const slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

    if (!trimmedTitle) {
      errors.title = "Product title is required.";
    }

    if (!trimmedSlug) {
      errors.slug = "Product slug is required.";
    } else if (!slugRegex.test(trimmedSlug)) {
      errors.slug = "Use lowercase letters, numbers, and hyphens only (no spaces).";
    }


    return {
      errors,
      isValid: !errors.title && !errors.slug,
      normalizedSlug: trimmedSlug,
      normalizedTitle: trimmedTitle,
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (submitting || loading) return;

    const { errors, isValid, normalizedSlug, normalizedTitle } = validateForm();
    setFieldErrors(errors);

    if (!isValid) {
      // Find the first invalid field and scroll/focus
      const invalidFields = Object.keys(errors).filter((key) => errors[key]);
      if (invalidFields.length > 0) {
        let refToFocus = null;
        if (invalidFields[0] === 'title') refToFocus = titleRef;
        else if (invalidFields[0] === 'slug') refToFocus = slugRef;
        if (refToFocus && refToFocus.current) {
          refToFocus.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
          refToFocus.current.focus();
        }
      }
      toast.error("Please fix the highlighted fields before submitting.");
      return;
    }

    try {
      setLoading(true);
      setSubmitting(true);
      const formData = new FormData();

      formData.append("title", normalizedTitle);
      formData.append("slug", normalizedSlug);
      formData.append("category", category?._id || "");
      macroFamily.forEach(mf => formData.append("macroFamily", mf._id));
      industry.forEach(ind => formData.append("industries", ind._id));

      // Add thumbnail image
      if (thumbnailFile) {
        formData.append("thumbnail_image", thumbnailFile);
      }

      // Add bulk images
      bulkImageFiles.forEach((file) => {
        formData.append("media.images", file);
      });

      // Add videos
      bulkVideos.forEach((video, index) => {
        const normalizedVideo = typeof video === "string"
          ? { url: video, title: "", description: "" }
          : {
            url: video?.url || "",
            title: video?.title || "",
            description: video?.description || "",
          };

        if (!normalizedVideo.url.trim()) return;

        formData.append(`media.videos[${index}][url]`, normalizedVideo.url.trim());
        formData.append(`media.videos[${index}][title]`, normalizedVideo.title.trim());
        formData.append(`media.videos[${index}][description]`, normalizedVideo.description.trim());
      });

      tags.forEach(tagId => formData.append("tags", tagId));

      // Add catalogues
      catalogEntries.forEach((catalog, index) => {
        const normalizedCatalog = {
          file: catalog?.file || null,
          title: catalog?.title || "",
          description: catalog?.description || "",
        };

        if (!normalizedCatalog.file) return;

        formData.append(`media.catalogs[${index}].url`, normalizedCatalog.file);
        formData.append(`media.catalogs[${index}].title`, normalizedCatalog.title.trim());
        formData.append(`media.catalogs[${index}].description`, normalizedCatalog.description.trim());
      });

      storeProduct(formData, {
        onSuccess: () => {
          toast.success("Product created successfully!", { autoClose: 2000 });
          setSubmitting(false);
          setLoading(false);
          redirectTimerRef.current = setTimeout(() => {
            navigate("/products/ProductList", {
              replace: true,
              state: {
                refreshProductsList: true,
                refreshToken: Date.now(),
              },
            });
          }, 1000);
        },
        onError: (error) => {
          const errorMessage =
            error?.response?.data?.message ||
            error?.message ||
            "Failed to create product";

          if (typeof errorMessage === "string" && /slug/i.test(errorMessage)) {
            setFieldErrors((prev) => ({ ...prev, slug: errorMessage }));
          }

          toast.error(errorMessage);
          setSubmitting(false);
          setLoading(false);
        },
      });
    } catch (error) {
      toast.error("Error creating product");
      console.error("Error:", error);
      setSubmitting(false);
      setLoading(false);
    }
  };


  const getOptionLabel = (option) => {
    if (typeof option === "string") return option;
    return option?.title || option?.name || "";
  };

  return (
    <>

      <div className="body">
        <div className="inputFields">
          <form onSubmit={handleSubmit}>
            <div
              className="form-header"
              style={{ display: "flex", gap: "20px", alignItems: "flex-start", flexWrap: "wrap" }}
            >
              <div
                className="text-inputs"
                style={{
                  flex: 1,
                  minWidth: 0,
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <div>
                  <label htmlFor="title">Title</label>
                  <input
                    type="text"
                    id="title"
                    ref={titleRef}
                    placeholder="Text here..."
                    value={title}
                    onChange={(e) => {
                      setTitle(e.target.value);
                      if (fieldErrors.title) {
                        setFieldErrors((prev) => ({ ...prev, title: "" }));
                      }
                    }}
                    style={{ width: "100%", marginTop: "10px" }}
                  />
                  {fieldErrors.title ? <p className="field-error">{fieldErrors.title}</p> : null}
                </div>
                <div>
                  <label htmlFor="subtitle">Slug</label>
                  <input
                    type="text"
                    id="slug"
                    ref={slugRef}
                    placeholder="Text here..."
                    value={slug}
                    onChange={(e) => {
                      setSlug(e.target.value.toLowerCase());
                      if (fieldErrors.slug) {
                        setFieldErrors((prev) => ({ ...prev, slug: "" }));
                      }
                    }}
                    style={{ width: "100%", marginTop: "10px" }}
                  />
                  {fieldErrors.slug ? <p className="field-error">{fieldErrors.slug}</p> : null}
                </div>

              </div>
              <div className="image-upload-section">
                <div className="avatar-upload" style={{ margin: "0" }}>
                  <div className="avatar-edit">
                    <input
                      type="file"
                      id="imageUpload"
                      accept=".png, .jpg, .jpeg"
                      onChange={(e) => readThumbnailURL(e.target)}
                    />
                    <label htmlFor="imageUpload"></label>
                  </div>
                  <div className="avatar-preview">
                    <div
                      id="imagePreview"
                      style={{ backgroundImage: `url(${thumbnailPreview})` }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </form>

          <div className="select-container">
            <form action="#" className="form">
              <label>Select Choices</label>
              <label style={{ textAlign: "left", marginBottom: "1px", fontWeight: "bold", fontSize: "1rem" }}>Macro Family</label>
              <Select
                isMulti
                options={macrofamilyOptions.map(option => ({ value: option._id, label: getOptionLabel(option), ...option }))}
                value={macroFamily.map(mfId => {
                  const mfObj = macrofamilyOptions.find(opt => opt._id === mfId._id);
                  return mfObj ? { value: mfObj._id, label: getOptionLabel(mfObj), ...mfObj } : null;
                }).filter(Boolean)}
                onChange={selected => setMacroFamily(selected.map(opt => ({ _id: opt.value })))}
                placeholder="Select one or more macro families..."
                styles={{
                  container: base => ({ ...base, width: "100%" }),
                  control: base => ({ ...base, minHeight: 44, fontSize: "1rem" }),
                  multiValue: base => ({ ...base, backgroundColor: "#2196f3", color: "#fff" }),
                  multiValueLabel: base => ({ ...base, color: "#fff" }),
                  multiValueRemove: base => ({ ...base, color: "#fff" })
                }}
              />

              <label style={{ textAlign: "left", marginBottom: "1px", fontWeight: "bold", fontSize: "1rem" }}>Industry</label>
              <Select
                isMulti
                options={industryOptions.map(option => ({ value: option._id, label: getOptionLabel(option), ...option }))}
                value={industry.map(indId => {
                  const indObj = industryOptions.find(opt => opt._id === indId._id);
                  return indObj ? { value: indObj._id, label: getOptionLabel(indObj), ...indObj } : null;
                }).filter(Boolean)}
                onChange={selected => setIndustry(selected.map(opt => ({ _id: opt.value })))}
                placeholder="Select one or more industries..."
                styles={{
                  container: base => ({ ...base, width: "100%" }),
                  control: base => ({ ...base, minHeight: 44, fontSize: "1rem" }),
                  multiValue: base => ({ ...base, backgroundColor: "#2196f3", color: "#fff" }),
                  multiValueLabel: base => ({ ...base, color: "#fff" }),
                  multiValueRemove: base => ({ ...base, color: "#fff" })
                }}
              />
              <select
                name="category"
                id="category"
                value={category?._id || ""}
                onChange={(e) => {
                  const selected = categoryOptions.find(opt => opt._id === e.target.value);
                  setCategory(selected || null);
                }}
              >
                <option value="">---Select Category---</option>
                {categoryOptions.map((option) => (
                  <option key={option._id} value={option._id}>
                    {getOptionLabel(option)}
                  </option>
                ))}
              </select>

              <div className="modal-tags-container">
                <div style={{ marginBottom: "20px" }}>
                  <label style={{ textAlign: "left", marginBottom: "10px", fontWeight: "bold", fontSize: "1rem" }}>
                    Select Tags
                  </label>
                  <Select
                    isMulti
                    options={tagOptions.map(option => ({ value: option._id, label: getOptionLabel(option) }))}
                    value={tags.map(tagId => {
                      const tagObj = tagOptions.find(opt => opt._id === tagId);
                      return { value: tagId, label: getOptionLabel(tagObj) };
                    })}
                    onChange={selected => setTags(selected.map(opt => opt.value))}
                    placeholder="Select one or more tags..."
                    styles={{
                      container: base => ({ ...base, minWidth: 220 }),
                      control: base => ({ ...base, minHeight: 36, fontSize: "0.95rem" }),
                      multiValue: base => ({ ...base, backgroundColor: "#2196f3", color: "#fff" }),
                      multiValueLabel: base => ({ ...base, color: "#fff" }),
                      multiValueRemove: base => ({ ...base, color: "#fff" })
                    }}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>

        <div className="uploadSection">
          <div className="UploadImages">
            <div className="bulkThumbnail">
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <h3>Bulk Image Upload</h3>
                <span style={{ color: "#888", fontSize: "0.95rem" }}>
                  Max 10 images
                </span>
              </div>
              <div className="bulkUpload">
                <div className="bulk-images-grid">
                  {bulkImagePreviews.map((img, index) => (
                    <div key={index} className="bulk-image-card" style={{ position: "relative" }}>
                      <img
                        src={img}
                        alt={`upload-${index}`}
                        onClick={() => handleImageClick(img, index)}
                        style={{ cursor: "pointer" }}
                      />
                      <button
                        className="delete-btn"
                        title="Delete image"
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          backgroundColor: "rgba(0,0,0,0.6)",
                          color: "white",
                          border: "none",
                          borderRadius: "50%",
                          width: "24px",
                          height: "24px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          fontSize: "16px"
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteImage(index);
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                  <div
                    className="add-new-card"
                    onClick={() => {
                      if (bulkImagePreviews.length < 10) {
                        document.getElementById("bulkImageInput").click();
                      }
                    }}
                    style={{
                      pointerEvents: bulkImagePreviews.length >= 10 ? "none" : "auto",
                      opacity: bulkImagePreviews.length >= 10 ? 0.5 : 1
                    }}
                  >
                    <span>+ Add New</span>
                  </div>
                </div>
                <input
                  type="file"
                  multiple
                  id="bulkImageInput"
                  style={{ display: "none" }}
                  onChange={handleBulkImageChange}
                  max={10}
                  disabled={bulkImagePreviews.length >= 10}
                />

              </div>
            </div>
          </div>

          <div className="fileUpload">
            <div className="upload-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <h3>Upload Catalogues</h3>
              <span style={{ color: "#888", fontSize: "0.95rem" }}>
                Max 10 entries
              </span>
            </div>

            <div className="upArea">
              <div className="url-input-container">
                <input
                  ref={catalogFileInputRef}
                  type="file"
                  accept=".pdf,application/pdf"
                  onChange={handleCatalogFileChange}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleAddCatalog(e);
                    }
                  }}
                />
                <input
                  type="text"
                  placeholder="Enter catalogue title"
                  value={catalogTitle}
                  onChange={(e) => setCatalogTitle(e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Enter catalogue description"
                  value={catalogDescription}
                  onChange={(e) => setCatalogDescription(e.target.value)}
                />
                <button
                  className="commonButton"
                  onClick={handleAddCatalog}
                  disabled={catalogEntries.length >= 10}
                >
                  Add Catalogue
                </button>
              </div>

              {catalogEntries.length > 0 && (
                <div className="file-list">
                  {catalogEntries.map((catalog, index) => (
                    <div key={index} className="file-item">
                      <div className="file-info-row">
                        <div className="file-icon">PDF</div>
                        <div className="file-details">
                          <div className="file-name">{catalog.title || catalog.file?.name || `Catalogue ${index + 1}`}</div>
                          <div className="file-meta">
                            <span className="file-size">{catalog.file?.name || "catalogue.pdf"}</span>
                          </div>
                          <div className="file-meta">{catalog.file ? `${(catalog.file.size / (1024 * 1024)).toFixed(2)} MB` : "0 MB"}</div>
                          {catalog.description ? <div className="file-meta">{catalog.description}</div> : null}
                        </div>
                      </div>
                      <div className="file-actions">
                        <button
                          className="delete-btn"
                          onClick={() => handleRemoveCatalog(index)}
                        >
                          <RiDeleteBin5Line />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="videoContainer">
          <h3 style={{ marginBottom: "7px" }}>Product Videos</h3>
          <div className="bulkUpload">
            <div className="url-input-container">
              <input
                type="text"
                placeholder="Enter YouTube URL (e.g., https://youtu.be/...)"
                value={videoUrl}
                onChange={(e) => setVideoUrl(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleAddVideoUrl(e);
                  }
                }}
              />
              <input
                type="text"
                placeholder="Enter video title"
                value={videoTitle}
                onChange={(e) => setVideoTitle(e.target.value)}
              />
              <input
                type="text"
                placeholder="Enter video description"
                value={videoDescription}
                onChange={(e) => setVideoDescription(e.target.value)}
              />
              <button onClick={handleAddVideoUrl} className="commonButton">Add Video</button>
            </div>
            <div className="bulk-video-grid">
              {bulkVideos.map((vid, index) => {
                const videoUrlValue = typeof vid === "string" ? vid : vid?.url || "";
                const videoTitleValue = typeof vid === "string" ? "" : vid?.title || "";
                const videoDescriptionValue = typeof vid === "string" ? "" : vid?.description || "";
                const embedUrl = getEmbedUrl(videoUrlValue);
                return (
                  <div key={index} className="bulk-video-card" style={{ position: "relative" }}>
                    {embedUrl ? (
                      <>
                        <iframe
                          width="100%"
                          height="100%"
                          src={embedUrl}
                          title={`video-${index}`}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                        <button
                          className="delete-btn"
                          onClick={() => handleRemoveVideo(index)}
                          style={{
                            position: "absolute",
                            top: "10px",
                            right: "10px",
                            backgroundColor: "rgba(0,0,0,0.7)",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            padding: "5px 10px",
                            cursor: "pointer",
                          }}
                        >
                          <RiDeleteBin5Line />
                        </button>
                        {(videoTitleValue || videoDescriptionValue) && (
                          <div style={{ padding: "8px", background: "#fff" }}>
                            {videoTitleValue ? <p style={{ margin: 0, fontWeight: 600 }}>{videoTitleValue}</p> : null}
                            {videoDescriptionValue ? <p style={{ margin: "4px 0 0 0" }}>{videoDescriptionValue}</p> : null}
                          </div>
                        )}
                      </>
                    ) : (
                      <div style={{ padding: "10px", textAlign: "center" }}>
                        <p>{videoUrlValue}</p>
                        {videoTitleValue ? <p style={{ margin: "6px 0 0 0", fontWeight: 600 }}>{videoTitleValue}</p> : null}
                        {videoDescriptionValue ? <p style={{ margin: "6px 0 0 0" }}>{videoDescriptionValue}</p> : null}
                        <button
                          className="delete-btn"
                          onClick={() => handleRemoveVideo(index)}
                        >
                          <RiDeleteBin5Line />
                        </button>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "flex-end",
            marginTop: "20px",
          }}
        >
          <button
            type="button"
            className="cancelBtn"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            type="submit"
            className="commonButton"
            disabled={submitting || loading}
            style={{ opacity: submitting || loading ? 0.65 : 1, cursor: submitting || loading ? "not-allowed" : "pointer" }}
          >
            {loading ? "Saving..." : "Save Product"}
          </button>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        className="image-preview-modal"
      >
        <div className="image-modal-wrapper">
          <img
            src={selectedImage}
            alt="Preview"
            className="modal-preview-image"
          />
          <button
            className="modal-delete-btn"
            onClick={() => {
              handleDeleteImage(selectedImageIndex);
              setIsModalOpen(false);
            }}
            title="Delete image"
          >
            <RiDeleteBin5Line />
          </button>
        </div>
      </Modal>
    </>
  );
};
export default AddProduct;
